<template>
  <TableLayout :permissions="['business:applicationinfo:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="应用名称" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入应用名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="服务商名称" prop="serverName">
        <el-input v-model="searchForm.serverName" placeholder="请输入服务商名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:applicationinfo:create']">
        <li><el-button type="primary" @click="$refs.operaApplicationInfoWindow.open('新建应用管理')" icon="el-icon-plus" v-permissions="['business:applicationinfo:create']">新建</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
      >
        <el-table-column prop="name" label="名称" min-width="100px"></el-table-column>
        <el-table-column label="LOGO" min-width="120px">
          <template slot-scope="{row}">
            <el-image
              v-if="row.fullLog"
              style="width: 100px; height: 100px"
              :src="row.fullLog"
              :preview-src-list="[row.fullLog]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="serverName" label="服务商" min-width="100px"></el-table-column>
        <el-table-column prop="lables" label="标签" min-width="100px"></el-table-column>
        <el-table-column prop="introduction" label="简介" min-width="100px"></el-table-column>
        <el-table-column prop="details" label="详情" min-width="100px">
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.protocol.open('详情', row.details || '<p></p>')">点击查看</el-button>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="100px">
          <template slot-scope="{row}">
            <el-switch
              v-model="row.status"
              @change="changeStatus($event, row.id)"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="0"
              :inactive-value="1">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          v-if="containPermissions(['business:applicationinfo:update', 'business:applicationinfo:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaApplicationInfoWindow.open('编辑应用管理', row)" icon="el-icon-edit" v-permissions="['business:applicationinfo:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:applicationinfo:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaApplicationInfoWindow ref="operaApplicationInfoWindow" @success="handlePageChange"/>
    <Protocol ref="protocol"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaApplicationInfoWindow from '@/components/business/OperaApplicationInfoWindow'
import { updateStatus } from '@/api/business/applicationInfo'
import Protocol from "@/components/Protocol.vue";
export default {
  name: 'ApplicationInfo',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaApplicationInfoWindow, Protocol },
  data () {
    return {
      // 搜索
      searchForm: {
        serverName: '',
        name: ''
      }
    }
  },
  created () {
    this.config({
      module: '应用管理',
      api: '/business/applicationInfo',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    changeStatus(status, id) {
      updateStatus({ id, status })
        .then(res => {
          this.search()
        })
    }
  }
}
</script>
